import React from "react";
import ReactHtmlParser from "react-html-parser";
import { QuestionIcon } from "./Icons";

interface Props {
  question: any;
  currentUser?: any;
  /** Used when the question's own description is unusable — see below. */
  fallback?: React.ReactNode;
}

/**
 * The lesson's instruction, in combo's Q bubble.
 *
 * The question's `description` is the instruction for almost every challenge in
 * this course, so widgets should not restate it in their own copy. Three
 * questions carry editorial placeholders there instead ("Nothing", "no
 * question", "insert big red heart-shaped button"); those widgets pass their own
 * `fallback` and the placeholder is never shown to a learner.
 */
const Prompt: React.FC<Props> = ({ question, currentUser, fallback }) => {
  const translation = question?.translations?.find(
    (t) => t.language === currentUser?.locale,
  );

  const description = translation
    ? translation?.formatted_description
    : question?.formatted_description;

  const body = fallback ?? (description ? ReactHtmlParser(description) : null);
  if (!body) return null;

  return (
    <div className="form-header">
      <div className="ui image">
        <QuestionIcon />
      </div>
      <div className="ui question">
        {/* @ts-ignore */}
        <div>{body}</div>
      </div>
    </div>
  );
};

export default Prompt;
